export default "__VITE_ASSET__DkBUjv4c__"